import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function yardReducer() {
  return combineReducers({
      yardListStatusComp: createItemReducer("CarrierHome", "TruckPlanDistributionLogWeb.ListYMQueue", false),
      yardListStatusCompParams: createItemReducerParams("CarrierHome", "TruckPlanDistributionLogWeb.ListYMQueue")
  });
}